export default __webpack_public_path__ + "static/genopets-1-a1e7b2b5a929665062d435633d62d95e.webp";